/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddDevicesToGroupDto } from '../../models/add-devices-to-group-dto';

export interface DeviceGroupControllerAddDevices$Params {
  id: string;
  clientWorkspaceId: string;
      body: AddDevicesToGroupDto
}

export function deviceGroupControllerAddDevices(http: HttpClient, rootUrl: string, params: DeviceGroupControllerAddDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deviceGroupControllerAddDevices.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deviceGroupControllerAddDevices.PATH = '/api/device-group/{clientWorkspaceId}/{id}/devices';
